export default "<div *ngIf=\"errMsg\" class=\"text-danger py-3 err-msg\">\n    <h4>{{errMsg}}</h4>\n  </div>"